
import { Form } from 'element-ui'
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import i18n from '@/lang'

@Component
export default class extends Vue {
  title = i18n.t('Informasi subjek') as string

  @Prop() visible!: boolean
  @Prop({ default: () => ({}) }) form!: { [key: string]: any }

  onOpen() {
    console.log(this.form)
  }

  @Emit('close')
  onClose() {
    // console.log('dialog closed')
    ;(this.$refs.form as Form).resetFields()
  }
}
